import { useCallback, useEffect, useState } from "react";
import { api as appel } from "./api";

export const api = {
  get: <T,>(url: string) => appel<T>(url),
  post: <T,>(url: string, body?: unknown) => appel<T>(url, { method: "POST", body: body ?? {} }),
  patch: <T,>(url: string, body?: unknown) => appel<T>(url, { method: "PATCH", body: body ?? {} }),
  put: <T,>(url: string, body?: unknown) => appel<T>(url, { method: "PUT", body: body ?? {} }),
  del: <T,>(url: string) => appel<T>(url, { method: "DELETE" }),
};

/** Charge une URL de l'API ; `recharger()` relance (après une action). */
export function useCharger<T>(url: string | null) {
  const [data, setData] = useState<T | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);
  const [tour, setTour] = useState(0);
  useEffect(() => {
    if (!url) return;
    let vivant = true;
    setErreur(null);
    appel<T>(url).then((d) => vivant && setData(d)).catch((e) => vivant && setErreur(e.message));
    return () => { vivant = false; };
  }, [url, tour]);
  const recharger = useCallback(() => setTour((t) => t + 1), []);
  return { data, erreur, recharger };
}
